// extracted by mini-css-extract-plugin
export var form = "_47-0";